// components/VillageSelect.tsx
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { DEFAULT_CROP_YEAR_ID } from 'Common/constants/cropYear';

interface Village {
  id: number;
  village: string;
}

interface VillageSelectProps {
  selectedVillage: any;
  onVillageChange: (village: any) => void;
  cropyearID?: number;
}

const VillageSelect: React.FC<VillageSelectProps> = ({
  selectedVillage,
  onVillageChange,
  cropyearID = DEFAULT_CROP_YEAR_ID
}) => {
  const [villagesList, setVillagesList] = useState<Village[]>([]);
  const [searchInput, setSearchInput] = useState<string>('');

  useEffect(() => {
    const fetchVillages = async () => {
      try {
        let url = `https://api.havirkesht.ir/village/?crop_year_id=${cropyearID}&sort_by=updated_at&sort_order=desc`;
        if (searchInput) {
          url += `&search=${encodeURIComponent(searchInput)}`;
        }
        
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('app_atkey')}`
          }
        });
        
        setVillagesList(response.data?.items || []);
      } catch (error) {
        console.error('Error fetching villages data:', error);
      }
    };

    fetchVillages();
  }, [searchInput, cropyearID]);

  const handleChange = (selectedOption: any) => {
    onVillageChange(selectedOption?.data || null);
  };

  const villageOptions = villagesList.map((village) => ({
    value: village.id,
    label: village.village,
    data: village
  }));

  const selectedValue = selectedVillage
    ? {
        value: selectedVillage.id,
        label: selectedVillage.village,
        data: selectedVillage
      }
    : null;

  return (
    <div className="flex flex-col">
      <label className="text-base font-medium mb-2 dark:text-white">
        روستا:
      </label>
      
      <Select
        options={villageOptions}
        value={selectedValue}
        onChange={handleChange}
        onInputChange={setSearchInput}
        styles={{
          control: (base, state) => ({
            ...base,
            minHeight: '44px',
            borderColor: state.isFocused ? '#4CAF50' : '#ddd',
            boxShadow: state.isFocused ? '0 0 0 1px #4CAF50' : 'none',
            '&:hover': {
              borderColor: state.isFocused ? '#4CAF50' : '#ccc'
            }
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 })
        }}
        menuPortalTarget={document.body}
        placeholder=" روستا راانتخاب کنید..."
        noOptionsMessage={() => 'روستا با این مشخصات یافت نشد'}
        loadingMessage={() => 'در حال بارگذاری...'}
        className="w-full my-react-select-container"
        classNamePrefix="my-react-select"
        maxMenuHeight={300}
        isClearable={true}
        isSearchable={true}
        closeMenuOnSelect={true}
      />
    </div>
  );
};

export default VillageSelect;